/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Local_PathInputs */



/**
* | output |
* | --- |
* | "Media Local Path" |
*
* @param {Media_Local_PathInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_local_path = /** @type {((inputs?: Media_Local_PathInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Local_PathInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chemin local du média")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien lokaler Pfad")
	if (locale === "it") return /** @type {LocalizedString} */ ("Percorso locale multimediale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Локальный путь к медиафайлу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ruta local de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体本地路径")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアのローカルパス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया लोकल पाथ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caminho Local de Mídia")
	return /** @type {LocalizedString} */ ("Media Local Path")
});